export const TABS = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
} as const

export const REVIEW_STATUS = {
  OPEN: 'open',
  READY: 'ready_for_review',
  COMPLETED: 'completed',
} as const

export const PULL_OPTIONS: Array<{
  label: string
  value: 'true' | 'false'
}> = [
  { label: 'Pull from field', value: 'true' },
  { label: 'Remain in field', value: 'false' },
]
